// extracted by mini-css-extract-plugin
module.exports = {"filler":"FullScreenLoader_filler__2ajRm","text":"FullScreenLoader_text__2iBvN"};